import axios from "axios";
import { store } from "../store";
import config from "../config";
import authHeader from "./auth-header";

const API_URL = config.API_URL;

const view = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;

  const page = values && values.page;
  const next_page_url = values && values.next_page_url;
  const result = values && values.result ? values.result : "";
  const pagetype = values && values.pagetype ? values.pagetype : "";
  // const pagination = values && values.option ? false : true;
  const sortstring = "";
  const action = page ? `afterlogin/staff/view?page=${page}}` : `afterlogin/staff/view`;
  const data = {
    auth_key: auth_key,
    action: action,
    pagination: false, //true or false
    id: values && values.id && values.id != "all_staff" ? values.id : "",
    result: result, //business_name,owner_name
    pagetype: pagetype,
    page_name: values && values.page_name ? values.page_name : "",
    singlestaffaccess: values && values.singlestaffaccess ? values.singlestaffaccess : "",
    option: values && values.option ? values.option : "",
    formName: values && values.formName ? values.formName : "",
  };
  return axios.post(next_page_url ? `${next_page_url}&${sortstring}` : API_URL + action, data, { headers: authHeader() });
};

const resourceitemview = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;

  const page = values && values.page;
  const next_page_url = values && values.next_page_url;
  const result = values && values.result ? values.result : "";
  const pagetype = values && values.pagetype ? values.pagetype : "";
  const resource_id = values && values.resource_id ? values.resource_id : "";
  // const pagination = values && values.option ? false : true;
  const action = page ? `afterlogin/resourceitem/view?page=${page}}` : `afterlogin/resourceitem/view`;
  const data = {
    auth_key: auth_key,
    action: action,
    pagination: false, //true or false
    id: values && values.id ? values.id : "",
    resource_id: resource_id,
    result: result, //business_name,owner_name
    pagetype: pagetype,
    page_name: values && values.page_name ? values.page_name : "",
    singlestaffaccess: values && values.singlestaffaccess ? values.singlestaffaccess : "",
    formName: values && values.formName ? values.formName : "",
  };
  return axios.post(next_page_url ? `${next_page_url}&${sortstring}` : API_URL + action, data, { headers: authHeader() });
};

const calendarApiController = {
  view,
  resourceitemview
};
export default calendarApiController;
